import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, RefreshCw, ArrowLeft, Phone, Globe } from "lucide-react";
import api from "../lib/api";

export default function Admin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/leads")
      .then((r) => setLeads(r.data || []))
      .catch(() => setLeads([]))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const fmtDate = (d) => {
    try { return new Date(d).toLocaleString(); } catch { return d; }
  };

  return (
    <div className="App min-h-screen grid-bg">
      <div className="max-w-[1100px] mx-auto px-5 md:px-8 py-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <Link to="/" className="inline-flex items-center gap-2 label text-[var(--muted)] hover:text-[var(--text)] transition-colors mb-4">
              <ArrowLeft size={13} /> Back to site
            </Link>
            <h1 className="display text-3xl flex items-center gap-3">
              <Inbox size={26} className="text-accent" /> Lead inbox
            </h1>
            <p className="text-[13px] text-[var(--muted)] mt-2">Requests submitted through the "Request more info" form.</p>
          </div>
          <button onClick={load} className="btn-ghost px-4 py-2.5 rounded-lg inline-flex items-center gap-2">
            <RefreshCw size={13} className={loading ? "animate-spin" : ""} /> Refresh
          </button>
        </div>

        <div className="mb-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="card rounded-2xl p-5">
            <div className="label text-[var(--muted)] text-[0.58rem] mb-2">Total leads</div>
            <div className="display text-3xl text-accent">{leads.length}</div>
          </div>
        </div>

        {loading ? (
          <div className="text-[var(--muted)] text-sm py-10">Loading…</div>
        ) : leads.length === 0 ? (
          <div className="card rounded-2xl p-10 text-center">
            <Inbox size={32} className="text-[var(--muted)] mx-auto mb-4" />
            <p className="text-[var(--muted)] text-sm">No leads yet. Submitted requests will appear here.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {leads.map((l) => (
              <div key={l.id} className="card rounded-2xl p-5">
                <div className="flex items-start justify-between gap-4 flex-wrap">
                  <div>
                    <div className="text-[15px] font-semibold text-[var(--text)]">{l.name}</div>
                    <div className="flex flex-wrap gap-4 mt-2 text-[13px] text-[var(--muted)]">
                      {l.phone && <span className="inline-flex items-center gap-1.5"><Phone size={13} className="text-accent" /> {l.phone}</span>}
                      {l.discord && <span className="inline-flex items-center gap-1.5"><Globe size={13} className="text-accent" /> {l.discord}</span>}
                      {l.email && <span className="inline-flex items-center gap-1.5"><Globe size={13} className="text-accent" /> {l.email}</span>}
                    </div>
                    <div className="flex flex-wrap gap-2 mt-3">
                      {l.watched_webinar && <span className="label text-[0.56rem] px-2.5 py-1 rounded-lg border border-white/10 text-[var(--muted)]">Webinar: {l.watched_webinar}</span>}
                      {l.stage && <span className="label text-[0.56rem] px-2.5 py-1 rounded-lg border border-white/10 text-[var(--muted)]">{l.stage}</span>}
                      {l.introducer && <span className="label text-[0.56rem] px-2.5 py-1 rounded-lg border border-white/10 text-[var(--muted)]">Ref: {l.introducer}</span>}
                    </div>
                    {l.note && <p className="mt-3 text-[13px] text-[var(--muted)] max-w-2xl leading-relaxed border-l-2 border-accent/30 pl-3">{l.note}</p>}
                  </div>
                  <span className="mono text-[11px] text-[var(--muted)]">{fmtDate(l.created_at)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
